import styled from 'styled-components'

export default styled.div`
    margin-bottom: ${({ theme }) =>theme.paddingBox};
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`
